/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";

// import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";
import routes from "routes.js";
import ThemeDropdown from "components/ThemeDropdown";

const Sidebar = ({ open, onClose }) => {
  return (
    <div
      className={`sm:none duration-300 linear fixed !z-50 flex min-h-full flex-col bg-[#5a88c6] pb-10 shadow-2xl shadow-black/20 transition-all backdrop-blur-sm border-r border-[#4a7bb6] md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden p-2 rounded-lg bg-white/20 hover:bg-white/30 transition-colors"
        onClick={onClose}
      >
        <HiX className="h-5 w-5 text-white" />
      </span>

      <div className="mx-6 mt-8 flex items-center">
        <div className="flex items-center space-x-3">
          <div className="p-2 rounded-xl bg-[#4a7bb6] shadow-lg">
            <span className="text-white font-bold text-xl">✈️</span>
          </div>
          <div>
            <div className="text-xl font-bold text-black">
              <span className="text-white">BCD</span>
              <span className="text-slate-300 ml-1">Travel</span>
            </div>
            <p className="text-slate-400 text-xs">Booking Management</p>
          </div>
        </div>
      </div>
      <div className="mt-8 mb-6 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent" />
      {/* Nav item */}

      <ul className="mb-auto pt-1 px-4">
        <Links routes={routes} />
        <li className=""><ThemeDropdown/></li>
      </ul>

      {/* Footer */}
      <div className="px-6 py-4">
        <div className="p-4 rounded-xl bg-white/10 border border-white/20">
          <p className="text-slate-300 text-sm font-medium">Need Help?</p>
          <p className="text-slate-400 text-xs mt-1">Contact support for assistance</p>
        </div>
      </div>

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
